var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',[_c('a',[_vm._v("WebSocket服务")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }